<template>
  <div class="drop-menu">
    <div class="drop-menu-block">
      <div class="item" v-for="(product, key) in productList" :key="key">
        <div class="title">{{ product.title }}</div>
        <div class="content" :class="[key]">
          <img
            @click="navigation(product.url)"
            v-for="(product, index) in product.imgArr"
            :key="index"
            :src="product.imgUrl"
            alt=""
            srcset=""
            class="content-item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

const productList = {
  quality: {
    title: "素质教育",
    imgArr: [
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/%E5%AD%A6%E8%80%8C%E6%80%9D%E7%B4%A0%E5%85%BB-1702177345792.png",
        url: "https://www.speiyou.com/home",
      },
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/%E5%AD%A6%E8%80%8C%E6%80%9D%E7%BD%91%E6%A0%A1-1702177345794.png",
        url: "https://online.xueersi.com",
      },
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/%E5%BD%BC%E8%8A%AF-1702177345792.png",
        url: "https://mp.weixin.qq.com/s/Grl9k-rKb-H6YTwxfZc-dg",
      },
    ],
  },
  hardware: {
    title: "智能硬件",
    imgArr: [
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/%E5%AD%A6%E8%80%8C%E6%80%9D%E6%99%BA%E8%83%BD-1702177345794.png",
        url: "https://xpad.xueersi.com?source_id=61",
      },
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/mathgpt-1702177345796.png",
        url: "https://www.mathgpt.com/",
      },
      {
        imgUrl:
          "https://talbook-cdn.oss-cn-beijing.aliyuncs.com/xueersi_web/web/home/mobi.png",
        url: "https://item.m.jd.com/product/13973608.html?utm_source=iosapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL&ad_od=share&gx=RnAonyIKMWWFkt0Upox-EdCzKQ&gxd=RnAolTRfYTDczZ1Hr9IkWttUYHCwLlhwsn9FvQCVMeyh9yjP1eICsmJOpFwY-Gk",
      },
      // {
      //   imgUrl:
      //     "https://editor.xesimg.com/tailor/resource/%E5%AD%A6%E8%80%8C%E6%80%9D%E5%9B%BE%E4%B9%A6-1702177345793.png",
      //   url: "http://www.xesvip.cn",
      // },
    ],
  },
  ibook: {
    title: "智能图书",
    imgArr: [
      {
        imgUrl:
          "https://talbook-cdn.oss-cn-beijing.aliyuncs.com/xueersi_web/web/home/intelligence.png",
        url: "/ibook",
      },
    ],
  },
  international: {
    title: "国际教育",
    imgArr: [
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/Group1321315825-1702177345795.png",
        url: "https://www.hiworld.com",
      },
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/thinkacademy-1702177345797.png",
        url: "https://www.thethinkacademy.com",
      },
    ],
  },
  collegeStudent: {
    title: "大学生课程",
    imgArr: [
      {
        imgUrl:
          "https://editor.xesimg.com/tailor/resource/Frame34-1702177345795.png",
        url: "https://www.qz100.com/home",
      },
    ],
  },
};
const navigation = (url) => {
  if (url === "/ibook") {
    router.push(url);
    return;
  }
  window.open(url, "_blank");
};
</script>

<style scoped lang="less">
.drop-menu {
  //   padding-top: 78px;
  &::before {
    content: " ";
    width: 200px;
    height: 79px;
    position: absolute;
    top: -70px;
    right: -0;
  }
  .drop-menu-block {
    display: flex;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 30px;
    display: flex;
    background: #fff;
    border-radius: 10px;
    .item {
      .title {
        color: #000;
        font-family: PingFang SC;
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
      }
      .content {
        margin-top: 12px;
        width: 164px;
        height: 188px;
        flex-shrink: 0;
        background-color: #f4f5f7;
        border-radius: 10px;
        margin-right: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
        .content-item {
          width: 124px;
          height: 36px;
          margin-bottom: 20px;
        }
        &.international {
          width: 188px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          .content-item {
            width: 64px;
            height: 43px;
            flex-shrink: 0;
            margin-right: 20px;
          }
        }
        &.collegeStudent {
          .content-item {
            width: 121.29px;
            height: 40px;
          }
        }
      }
    }
  }
}
</style>
